/*
  KNAKRD header hint (PDP LAB 20 Sep 2026). Hover-open already lives in menu-hover.js.
  This only draws the hairline under Catalog once, on a first homepage visit, so the eye
  lands on the way into the shop. Once per session, never with reduced motion.
*/
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const run = () => {
    if (!document.body.classList.contains('kn-page-index')) return;
    const first = document.querySelector('.header__inline-menu header-menu > details > .header__menu-item');
    if (!first) return;
    let seen = false;
    try { seen = sessionStorage.getItem('kn-catalog-hint') === '1'; } catch (e) {}
    if (seen) return;
    first.classList.add('kn-draw');
    setTimeout(() => first.classList.add('is-drawn'), 900);
    setTimeout(() => first.classList.remove('kn-draw', 'is-drawn'), 2600);
    try { sessionStorage.setItem('kn-catalog-hint', '1'); } catch (e) {}
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
})();
